import {FormSection} from '@/components/commons/form-section/FormSection'
import {TKey, useTranslation} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {InputText} from '@/components/commons/input-text/InputText'
import {CompanyInfoFormValidationSchema} from '@/features/company-info/types'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {ObjectEntries} from '@/utilities/helpers'

// Create option entries arrays for select inputs
const regimeOptionsMap = {
    residential: 'company_info:form:residential',
    non_residential: 'company_info:form:non_residential'
}

const modalityOptionsMap = {
    outpatient: 'company_info:form:outpatient',
    home_care: 'company_info:form:home_care'
} as Record<string, string>

const aslOptionsEntries = [['120201', 'ASL RM1']] as [string, string][]

export const StructureInfoSection = () => {
    const {t} = useTranslation()
    const {
        register,
        formState: {errors}
    } = useFormContext<CompanyInfoFormValidationSchema>()

    // Use useController for select inputs
    const regimeTypeController = useController({name: 'regimeType'})
    const modalityTypeController = useController({name: 'modalityType'})
    const aslReferenceController = useController({name: 'aslReference'})

    return (
        <FormSection title={t('company_info:form:company_type_section_title')} hasBottomDivider>
            <Grid columns={2} gap={4}>
                <GridItem>
                    <InputText
                        label={t('company_info:form:company_type_label')}
                        type="text"
                        errorMessage={errors.structureType?.message}
                        touched={!!errors.structureType}
                        {...register('structureType')}
                    />
                </GridItem>
                <GridItem>
                    <InputSelect
                        label={t('company_info:form:assistential_type_label')}
                        optionsEntries={ObjectEntries(regimeOptionsMap).map(([key, value]) => [
                            key.toString(),
                            t(value as TKey)
                        ])}
                        value={regimeTypeController.field.value}
                        onChange={regimeTypeController.field.onChange}
                        errorMessage={errors.regimeType?.message}
                    />
                </GridItem>
                <GridItem>
                    <InputSelect
                        label={t('company_info:form:modality_type_label')}
                        optionsEntries={ObjectEntries(modalityOptionsMap).map(([key, value]) => [
                            key.toString(),
                            t(value as TKey)
                        ])}
                        value={modalityTypeController.field.value}
                        onChange={modalityTypeController.field.onChange}
                        errorMessage={errors.modalityType?.message}
                    />
                </GridItem>
                <GridItem>
                    <InputText
                        label={t('company_info:form:nis_code_label')}
                        type="text"
                        errorMessage={errors.nisCode?.message}
                        touched={!!errors.nisCode}
                        {...register('nisCode')}
                    />
                </GridItem>
                <GridItem>
                    <InputSelect
                        label={t('company_info:form:asl_reference_label')}
                        optionsEntries={aslOptionsEntries}
                        value={aslReferenceController.field.value}
                        onChange={aslReferenceController.field.onChange}
                        errorMessage={errors.aslReference?.message}
                    />
                </GridItem>
            </Grid>
        </FormSection>
    )
}
